import React from 'react';
import { ModularButtonBlockType } from '@appTypes/ModularButtonBlockType';
import { ModularButton } from '@components/ModularButton/ModularButton';

export const ModularButtonBlock = ({ block }: { block: ModularButtonBlockType }) => (
  <ModularButton primaryButton={block.primaryButton} secondaryButton={block?.secondaryButton} />
);
